import { useTranslation } from "react-i18next";
import { Button, Text } from "@ucl/react-library";


export const QuestionsAboutScheme = ({ standardInfo = true }: { standardInfo?: boolean }) => {
  const { t } = useTranslation();
  const titleKey = standardInfo ? "title" : "infoSupportTitle";
  const infoKey = standardInfo ? "questionsInfo" : "infoSupportInfo";
  return (
    <div className="flex flex-col gap-5 items-start text-start" data-testid="questionsAboutScheme">
      <Text renderAs="h2" styleType="h4" fontWeight="semi-bold">
        {t(`questionsAboutScheme.${titleKey}`)}
      </Text>
      <Text.P size="large">{t(`questionsAboutScheme.${infoKey}`)}</Text.P>
      <Button as="a" href={t("links.faqLink")} target="_blank" variant="secondary">
        {t("questionsAboutScheme.goToFaqs")}
      </Button>
    </div>
  );
};